import { gql } from "@apollo/client";

export const NOTIFY_MMM_DATA_READY = gql`
  mutation NotifyMMMDataIsReady($cycleId: String!) {
    notifyMMMDataIsReady(cycle_id: $cycleId) {
      message
    }
  }
`;
